import React, { useReducer, useContext, createContext } from "react";

const initialState = {
  modalHistory: [],
};

export const ACTIONS = {
  PUSH_END: "PUSH_END",
  POP_END: "POP_END",
  POP_ALL: "POP_ALL",
};
const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.PUSH_END:
      return {
        ...state,
        modalHistory: [...state.modalHistory, action.payload.value],
      };
    case ACTIONS.POP_END:
      const newModalHistory = [...state.modalHistory];
      newModalHistory.pop();
      return {
        ...state,
        modalHistory: newModalHistory,
      };
    case ACTIONS.POP_ALL:
      return {
        ...state,
        modalHistory: [],
      };
    default:
      return state;
  }
};

const ModalHistoryContext = createContext(initialState);

export default function ModalHistoryProvider({ children }) {
  return (
    <ModalHistoryContext.Provider value={useReducer(reducer, initialState)}>
      {children}
    </ModalHistoryContext.Provider>
  );
}

export const useModalHistory = () => useContext(ModalHistoryContext);
